import React, { useRef, useState } from "react";
import styled from "styled-components";
import "./Contact.css";
import toast from "react-hot-toast";
import axios from "axios";


const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  @media (max-width: 960px) {
    padding: 0px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1350px;
  padding: 0px 0px 80px 0px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 42px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 16px;
  }
`;

const ContactForm = styled.form`
  width: 95%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.card};
  padding: 32px;
  border-radius: 16px;
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
  margin-top: 28px;
  gap: 12px;
`;

const LoadingSpinner = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  margin-right: 8px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const ContactButton = styled.button`
  background-color: ${({ loading, theme }) => (loading ? "green" : theme.primary)};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  outline:none;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Error = styled.div`
  color: red;
  font-size: 14px;
  margin-top: 4px;
`;

const Contact = () => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const form = useRef();

  const validateForm = () => {
    const formElements = form.current.elements;
    let isValid = true;
    let newErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    for (let element of formElements) {
      if (element.required && !element.value.trim()) {
        newErrors[element.name] = `${element.placeholder} is required`;
        isValid = false;
      }
      else if (element.name === 'from_email' && element.value.trim() && !emailRegex.test(element.value.trim())) {
        newErrors[element.name] = "Please enter a valid email address";
        isValid = false;
      }
    }

    // // Specifically validate the subject and message fields
    // if (!form.current.subject.value.trim()) {
    //   newErrors.subject = "Subject is required";
    //   isValid = false;
    // }
    // if (!form.current.message.value.trim()) {
    //   newErrors.message = "Message is required";
    //   isValid = false;
    // }

    setErrors(newErrors);
    return isValid;
  };


  const sendEmail = async (e) => {
    e.preventDefault(); // Prevent form from refreshing the page

    if (!validateForm()) {
      return; // Stop form submission if validation fails
    }

    const formData = new FormData(form.current);
    const formObj = Object.fromEntries(formData.entries());
    try {
      setLoading(true);
      // `http://localhost:5001/api/user/send-portfolio-query-mail`,
      // `https://emp-app-rho.vercel.app/api/user/send-portfolio-query-mail`,
      const response = await axios.post(
        `https://emp-app-rho.vercel.app/api/user/send-portfolio-query-mail`,
        formObj,
        {
          headers: {
            Authorization: `Bearer a1b2c3d4`,
          },
        }
      );
      // console.log("response api", response)
      // return response.data;
      if (response?.data?.success) {
        toast.success(
          `Thank you for reaching out!\nI'll get back to you soon...!`,
          {
            duration: 5000,
            position: "top-center",
            style: {
              whiteSpace: 'pre-line',
            },
          }
        );
        form.current.reset();
        setErrors({}); // Clear form after successful submission
      } else {
        toast.error(
          `Oops! Something went wrong.\nPlease try again later..!`,
          {
            duration: 5000,
            position: "top-center",
            style: {
              whiteSpace: 'pre-line',
            },
          }
        );
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        `An error occurred.\nPlease check your details and try again...!`,
        {
          duration: 5000,
          position: "top-center",
          style: {
            whiteSpace: 'pre-line',
          },
        }
      );
    } finally {
      setLoading(false); // Stop loading
    }
  };


  return (
    <Container>
      <Wrapper>
        <Title>Contact</Title>
        <Desc>
          Feel free to reach out to me for any questions or opportunities!
        </Desc>
        <ContactForm ref={form} onSubmit={sendEmail}>
          <div className="contact-title">Email Me 🚀</div>
          <input
            className="contact-input"
            autoComplete="on"
            placeholder="Your Email"
            name="from_email"
            required
          />
          {errors.from_email && <Error>{errors.from_email}</Error>}
          <input
            className="contact-input"
            autoComplete="on"
            placeholder="Your Name"
            name="from_name"
            required
          />
          {errors.from_name && <Error>{errors.from_name}</Error>}
          <input
            className="contact-input"
            autoComplete="on"
            placeholder="Subject"
            name="subject"
            required
          />
          {errors.subject && <Error>{errors.subject}</Error>}
          <textarea
            className="contact-input-message"
            autoComplete="on"
            placeholder="Message"
            rows="4"
            name="message"
            required
          />
          {errors.message && <Error>{errors.message}</Error>}
          <ContactButton type="submit" loading={loading} disabled={loading}>
            {loading ? (
              <LoadingDiv>
                <LoadingSpinner /> Sending...
              </LoadingDiv>
            ) : (
              "Send"
            )}
          </ContactButton>
        </ContactForm>
      </Wrapper>
    </Container>
  );
};

export default Contact;


// import React, { useRef, useState } from "react";
// import styled from "styled-components";
// import "./Contact.css";
// import toast from "react-hot-toast";

// const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   position: relative;
//   z-index: 1;
//   align-items: center;
//   @media (max-width: 960px) {
//     padding: 0px;
//   }
// `;

// const Wrapper = styled.div`
//   position: relative;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-direction: column;
//   width: 100%;
//   max-width: 1350px;
//   padding: 0px 0px 80px 0px;
//   gap: 12px;
//   @media (max-width: 960px) {
//     flex-direction: column;
//   }
// `;

// const Title = styled.div`
//   font-size: 42px;
//   text-align: center;
//   font-weight: 600;
//   margin-top: 20px;
//   color: ${({ theme }) => theme.text_primary};
//   @media (max-width: 768px) {
//     margin-top: 12px;
//     font-size: 32px;
//   }
// `;

// const Desc = styled.div`
//   font-size: 18px;
//   text-align: center;
//   max-width: 600px;
//   color: ${({ theme }) => theme.text_secondary};
//   @media (max-width: 768px) {
//     margin-top: 12px;
//     font-size: 16px;
//   }
// `;

// const ContactForm = styled.form`
//   width: 95%;
//   max-width: 600px;
//   display: flex;
//   flex-direction: column;
//   background-color: ${({ theme }) => theme.card};
//   padding: 32px;
//   border-radius: 16px;
//   box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
//   margin-top: 28px;
//   gap: 12px;

//   .contact-input,
//   .contact-input-message {
//     // color: black; /* Set text color to black */
//   }
// `;

// const LoadingSpinner = styled.div`
//   border: 3px solid #f3f3f3;
//   border-top: 3px solid #3498db;
//   border-radius: 50%;
//   width: 16px;
//   height: 16px;
//   animation: spin 1s linear infinite;
//   margin-right: 8px;

//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `;

// const LoadingDiv = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: center;
//   align-items: center;
//   width: 100%;
// `;
// const ContactButton = styled.button`
//     background-color: ${({ loading, theme }) => (loading ? "green" : theme.primary)};
//   color: white;
//   border: none;
//   padding: 10px 20px;
//   border-radius: 5px;
//   cursor: pointer;
//   font-size: 16px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 100%;
//   outline:none;

//   &:disabled {
//     opacity: 0.6;
//     cursor: not-allowed;
//   }
// `;


// const Contact = () => {
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);


//   const form = useRef();
//   const validateForm = () => {
//     const formElements = form.current.elements;
//     let isValid = true;
//     let newErrors = {};

//     for (let element of formElements) {
//       if (element.required && !element.value.trim()) {
//         newErrors[element.name] = "This field is required";
//         isValid = false;
//       }
//     }

//     setErrors(newErrors);
//     return isValid;
//   };


//   const sendEmail = async (e) => {
//     e.preventDefault(); // Prevent form from refreshing the page

//     if (!validateForm()) {
//       return; // Stop form submission if validation fails
//     }

//     const formData = new FormData(form.current);
//     const formObj = Object.fromEntries(formData.entries());

//     try {
//       setLoading(true);
//       const response = await fetch("http://localhost:5000/send-email", {
//         // const response = await fetch("https://champalalsutharcuhbackend.vercel.app/send-email", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formObj),
//       });

//       if (response.ok) {
//         toast.success(
//           `Thank you for reaching out!\nI'll get back to you soon...!`,
//           {
//             duration: 5000,
//             position: "top-center",
//             style: {
//               whiteSpace: 'pre-line',
//             },
//           }
//         );
//         // form.current.reset();
//         setErrors({}); // Clear form after successful submission
//       } else {
//         toast.error(
//           `Oops! Something went wrong.\nPlease try again later..!`,
//           {
//             duration: 5000,
//             position: "top-center",
//             style: {
//               whiteSpace: 'pre-line',
//             },
//           }
//         );
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast.error(
//         `An error occurred.\nPlease check your details and try again...!`,
//         {
//           duration: 5000,
//           position: "top-center",
//           style: {
//             whiteSpace: 'pre-line',
//           },
//         }
//       );
//     } finally {
//       setLoading(false); // Stop loading
//     }
//   };

//   return (
//     <Container>
//       <Wrapper>
//         <Title>Contact</Title>
//         <Desc>
//           Feel free to reach out to me for any questions or opportunities!
//         </Desc>
//         <ContactForm ref={form} onSubmit={sendEmail}>
//           <div className="contact-title">Email Me 🚀</div>
//           <input
//             className="contact-input"
//             autoComplete="on"
//             placeholder="Your Email"
//             name="from_email"
//             required
//           />
//           {errors.from_email && <div className="error-message">{errors.from_email}</div>}
//           <input
//             className="contact-input"
//             autoComplete="on"
//             placeholder="Your Name"
//             name="from_name"
//             required
//           />
//           {errors.from_name && <div className="error-message">{errors.from_name}</div>}
//           <input
//             className="contact-input"
//             autoComplete="on"
//             placeholder="Subject"
//             name="subject"
//             required
//           />
//           {errors.subject && <div className="error-message">{errors.subject}</div>}
//           <textarea
//             className="contact-input-message"
//             autoComplete="on"
//             placeholder="Message"
//             rows="4"
//             name="message"
//             required
//           />
//           {errors.message && <div className="error-message">{errors.message}</div>}
//           <ContactButton type="submit" loading={loading} disabled={loading}>
//             {loading ? (
//               <LoadingDiv>
//                 <LoadingSpinner /> Sending...
//               </LoadingDiv>
//             ) : (
//               "Send"
//             )}
//           </ContactButton>
//         </ContactForm>
//       </Wrapper>
//     </Container >
//   );
// };

// export default Contact;